import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import Bannerimg from "../../../images/banner/bigdata-banner.webp";
const BigData = () => {
  const banner = {
    title: "Big Data",
    image: Bannerimg,
  };
  return (
    <>
      <Helmet>
        <title>
          Big Data — Cylon Technologies – Big Data | Data Analytics | Digital
          Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Big Data </h2>
              <p>
                In the Information Age, data is king. Big Data is an invaluable
                resource to helping your business improve service, maximize
                assets, and grow to new heights. The ability to gain real-time
                insights and give yourself an edge over the competition is an
                unparalleled advantage in today’s market.
              </p>
              <p>
                Cylon provides our customers experts who can help you build and
                grow your advanced analytical capabilities with ease. <br />{" "}
                Identify and predict trends, know who your customer is and how
                they think, make smarter business decisions and improve your
                market share with the help of our resources.
              </p>
              <h5>Cylon Technologies Advantage</h5>

              <ul>
                <li>
                  1. Expertise in Designing complex BigData and BI Solutions
                </li>
                <li>
                  2. Providing 24*7 support for our customer projects and needs
                </li>
                <li>
                  3. Access to our expert Talent pool in BigData and Data
                  Science platforms
                </li>
                <li>
                  4. Expertise in Data Integration, Data governance, Data
                  Quality, Data Security and Data
                </li>
                <li>Lineage</li>
              </ul>
            </div>
            <div className="col-md-4">
              <div className="right_content">
                <div className="border-tb mb-5">
                  <h2 className="heading2 mt-0">Big Data Skills</h2>
                  <ul>
                    <li>Tableau</li>
                    <li>Pentaho</li>
                    <li>TIBCO Spotfire</li>
                    <li>Qlikview</li>
                    <li>Splunk</li>
                    <li>Hadoop/MapR</li>
                    <li>Pig &amp;amp; Hive</li>
                    <li>Cassandra</li>
                    <li>Spark</li>
                    <li>Kafka</li>
                    <li>Nifi</li>
                    <li>Data Science with Python, R, TensorFlow</li>
                  </ul>
                </div>
                <h2 className="heading2">Roles Performed</h2>
                <ul data-rte-list="default">
                  <li>Hadoop developer</li>
                  <li>Big Data Developer</li>
                  <li>Big Data Architect</li>
                  <li>Digital Data Analyst</li>
                  <li>Digital Data Scientist</li>
                  <li>Big Data Hadoop Administrator</li>
                  <li>Big Data &amp;amp; Metrics Director</li>
                  <li>Technology – Digital Finance Tech – Data Engineering</li>
                  <li>Big Data Solutions Architect</li>
                  <li>Data Analyst</li>
                  <li>Hadoop Analytics Analyst</li>
                  <li>Digital Analytics Strategist</li>
                  <li>Global Digital Experience Consultant</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BigData;
